import { Flex, Heading } from "@aws-amplify/ui-react";
const HealthRecordsDocumentVideosPage = () => {
  return (
    <Flex
      gap="24px"
      direction="column"
      width="unset"
      height="unset"
      justifyContent="flex-start"
      alignItems="flex-start"
      position="relative"
      padding="32px 32px 32px 32px"
      backgroundColor="rgba(250,250,250,1)"
    >
      <Heading
        width="unset"
        height="unset"
        shrink="0"
        level="3"
        children="MRI (Magnetic Resonance Imaging)"
      ></Heading>
      <video width={650} controls>
        <source src="/videos/mri1.mov"></source>
      </video>
      <video width={650} controls>
        <source src="/videos/mri2.mov"></source>
      </video>
    </Flex>
  );
};

export default HealthRecordsDocumentVideosPage;
